"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeTime = void 0;
const computeTime = (now, absolute, relative, forceTimeToBeAfterNow = false, timezoneOffset = 0) => {
    let result = new Date(now);
    result.setSeconds(0, 0);
    relative.forEach((e) => {
        switch (e.period) {
            case "MINUTE": {
                result.setTime(result.getTime() + 1000 * 60 * e.value);
                break;
            }
            case "HOUR": {
                result.setTime(result.getTime() + 1000 * 60 * 60 * e.value);
                break;
            }
            case "DAY":
            case "DAY_OF_MONTH": {
                result.setTime(result.getTime() + 1000 * 60 * 60 * 24 * e.value);
                break;
            }
            case "MONTH": {
                let newMonth = result.getMonth() + e.value;
                while (newMonth > 11) {
                    result.setFullYear(result.getFullYear() + 1);
                    newMonth -= 11;
                }
                result.setMonth(newMonth);
                break;
            }
            case "YEAR": {
                result.setFullYear(result.getFullYear() + e.value);
                break;
            }
            case "WEEK": {
                result.setTime(result.getTime() + e.value * 7 * 24 * 60 * 60 * 1000);
                break;
            }
        }
    });
    absolute.forEach((e) => {
        switch (e.period) {
            case "MINUTE": {
                result.setMinutes(e.value);
                break;
            }
            case "HOUR": {
                // const timezoneOffset = (now.getTimezoneOffset() / 60);
                result.setHours(e.value + timezoneOffset / 60);
                break;
            }
            case "DAY":
            case "DAY_OF_MONTH": {
                result.setDate(e.value);
                break;
            }
            case "MONTH": {
                result.setMonth(e.value - 1);
                break;
            }
            case "YEAR": {
                result.setFullYear(e.value);
                break;
            }
            case "DAY_OF_WEEK": {
                const weekDay = result.getDay();
                result = new Date(result.getTime() + (e.value - weekDay) * 24 * 60 * 60 * 1000);
                break;
            }
            case "WEEK": {
                const weekNb = getWeekNb(result);
                const adjustedTime = result.getTime() + (e.value - weekNb) * 7 * 24 * 60 * 60 * 1000;
                result = new Date(adjustedTime);
                break;
            }
        }
    });
    if (result > now || !forceTimeToBeAfterNow || absolute.length === 0) {
        return result;
    }
    else {
        if (absolute.find((e) => ["DAY_OF_WEEK"].includes(e.period)) &&
            !absolute.find((e) => ["WEEK"].includes(e.period))) {
            // try to add 1 week if the slot is available
            const newRelative = add1DimensionToRelativeTime("WEEK", relative);
            const newTimeToTest = (0, exports.computeTime)(now, absolute, newRelative);
            if (newTimeToTest > now) {
                return newTimeToTest;
            }
        }
        if (!absolute.find((e) => e.period === "HOUR")) {
            // try to add 1 hour if the slot is available
            const newRelative = add1DimensionToRelativeTime("HOUR", relative);
            const newTimeToTest = (0, exports.computeTime)(now, absolute, newRelative);
            if (newTimeToTest > now) {
                return newTimeToTest;
            }
        }
        if (!absolute.find((e) => ["DAY_OF_WEEK", "DAY", "DAY_OF_MONTH"].includes(e.period))) {
            // try to add 1 day if the slot is available
            const newRelative = add1DimensionToRelativeTime("DAY", relative);
            const newTimeToTest = (0, exports.computeTime)(now, absolute, newRelative);
            if (newTimeToTest > now) {
                return newTimeToTest;
            }
        }
        if (!absolute.find((e) => ["MONTH"].includes(e.period))) {
            // try to add 1 month if the slot is available
            const newRelative = add1DimensionToRelativeTime("MONTH", relative);
            const newTimeToTest = (0, exports.computeTime)(now, absolute, newRelative);
            if (newTimeToTest > now) {
                return newTimeToTest;
            }
        }
        if (!absolute.find((e) => ["YEAR"].includes(e.period))) {
            // try to add 1 year if the slot is available
            const newRelative = add1DimensionToRelativeTime("YEAR", relative);
            const newTimeToTest = (0, exports.computeTime)(now, absolute, newRelative);
            if (newTimeToTest > now) {
                return newTimeToTest;
            }
        }
    }
    return result;
};
exports.computeTime = computeTime;
const add1DimensionToRelativeTime = (dimension, relativeTime) => {
    return relativeTime.find((e) => e.period === dimension)
        ? relativeTime.map((e) => {
            if (e.period === dimension) {
                return {
                    period: dimension,
                    value: e.value + 1,
                };
            }
            else
                return e;
        })
        : [
            ...relativeTime,
            {
                period: dimension,
                value: 1,
            },
        ];
};
const getWeekNb = (date) => {
    //find the year of the entered date
    var oneJan = new Date(date.getFullYear(), 0, 1);
    // calculating number of days in given year before the given date
    var numberOfDays = Math.floor((date.getTime() - oneJan.getTime()) / (24 * 60 * 60 * 1000));
    // adding 1 since to current date and returns value starting from 0
    var result = Math.ceil((date.getDay() + 1 + numberOfDays) / 7);
    return result;
};
